import { reactive } from "vue";
import { productLibrary } from "../../data";

/**
 * Which product category the product selector shows.
 * The product categories live in productLibrary (not reactive); `version` is bumped to re-read them.
 */
export const productSelection = reactive({
    categoryType: "",
    version: 0,
});

/** Selects the first category that has products and re-reads the product library. */
export function resetProductSelector() {
    const first = (productLibrary.productsCategories ?? []).filter(pc => pc.products)[0];
    productSelection.categoryType = first?.type ?? "";
    productSelection.version++;
}

/** Re-reads the product library (e.g. after it was loaded for another series). */
export function refreshProductSelector() {
    productSelection.version++;
}
